import { withRouter } from 'react-router-dom'
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import React, { Fragment } from 'react';
import { Formik, Form, Field, ErrorMessage, FieldArray } from 'formik';
import estilos from '../Steps/StepsComponent.module.css'


function StepExtraccionDeMagueyComponent(props) {
    const [guiaFisica, setGuiaFisica] = React.useState([]);

    const [informacionFormik, setInformacionFormik] = React.useState(
        {

        }
    );

    const handleNuevoExtraccionDeMaguey = (valores) => {
    }

    const especies = ['Uno', 'Dos', 'Tres', 'Cuatro', 'Cinco'];

    const handleGuiaFisica = (event) => {
        if (event.target.files[0] != undefined) {
            setGuiaFisica([...guiaFisica, event.target.files[0]]);
        }
    }

    return (
        <Fragment>
            <div class='row' style={{ textAlign: 'center !important', paddingBottom: '3%' }}>
                <div class='col-2'></div>
                <div class='col-6'>
                    <TextField helperText="Ingresa el número de Guia o QR"
                        fullWidth
                        label="Consulta Número de Guía o QR"
                        id="fullWidth" />
                </div>
                <div class='col-1'>
                    <CheckCircleIcon fontSize='large' sx={{ color: 'green' }} />
                </div>
                <div class='col-3'>
                </div>
            </div>

            <Formik initialValues={informacionFormik}
                onSubmit={(valores) => {
                    handleNuevoExtraccionDeMaguey(valores)
                }}>
                {(props) => (
                    <Form>
                        
                        <div class='row' style={{ textAlign: 'center !important', padding: '1%', paddingBottom: '1%', border: '1px solid black' }}>
                            <label className={`${estilos.labelUI} mb-2`}>Extracción de Maguey</label>
                            <div class='col-6'>
                                <Field type="number" class="form-control" id="numerodepinas" name="numerodepinas" placeholder="Número de piñas" required />
                            </div>
                            <div class='col-6'>
                                <Field
                                    component="select"
                                    id="tipo"
                                    name="tipo"
                                    className="form-select"
                                    multiple={false}
                                    required
                                >
                                    <option defaultValue>Especie de Maguey</option>
                                    {especies.map((t, index) => (
                                        <option key={index} value={t}>{t}</option>
                                    ))}
                                </Field>

                            </div>
                        </div>

                        <br /><br />
                        <div class='row' style={{ textAlign: 'center !important', padding: '1%', paddingBottom: '1%', border: '1px solid black' }}>
                            <div class='col-6'>
                                <Field type="number" class="form-control" id="numerodepinas" name="numerodepinas" placeholder="Número de piñas" required /><br />
                                <Field type="file" className="form-control form-control-sm" id="guiaFisica" name="guiaFisica" placeholder="Ingrese el archivo Guia Fisica" multiple={false} required accept="image/png,image/jpeg" onChange={handleGuiaFisica}></Field>

                            </div>
                            <div class='col-6'>
                                <Field
                                    component="select"
                                    id="especiemaguey"
                                    name="especiemaguey"
                                    className="form-select"
                                    multiple={false}
                                    required
                                >
                                    <option defaultValue>Especie de Maguey</option>
                                    {especies.map((t, index) => (
                                        <option key={index} value={t}>{t}</option>
                                    ))}
                                </Field>


                            </div>
                        </div>

                        <br /><br />
                        <div class='row' style={{ textAlign: 'center !important', padding: '1%', paddingBottom: '1%', border: '1px solid black' }}>
                        <label className={`${estilos.labelUI} mb-2`}>Evidencia Fotográfica</label>
                            <div class='col-4'>
                                <label for="guiaFisica"> Guia de Maguey COMERCAM</label>
                                <Field type="file" className="form-control form-control-sm" id="guiaFisica" name="guiaFisica" placeholder="Ingrese el archivo Guia Fisica" multiple={false} required accept="image/png,image/jpeg" onChange={handleGuiaFisica}></Field>

                            </div>
                            <div class='col-4'>
                            <label for="guiaFisica"> Guia de Maguey Externo</label>
                                <Field type="file" className="form-control form-control-sm" id="guiaFisica" name="guiaFisica" placeholder="Ingrese el archivo Guia Fisica" multiple={false} required accept="image/png,image/jpeg" onChange={handleGuiaFisica}></Field>
                            </div>
                            <div class='col-4'>
                            <label for="guiaFisica"> Guia en registro</label>
                                <Field type="file" className="form-control form-control-sm" id="guiaFisica" name="guiaFisica" placeholder="Ingrese el archivo Guia Fisica" multiple={false} required accept="image/png,image/jpeg" onChange={handleGuiaFisica}></Field>
                            </div>
                        </div>
                    </Form>
                )}
            </Formik>
        </Fragment>
    )

}
export default withRouter(StepExtraccionDeMagueyComponent)